module.exports = __webpack_public_path__ + "img/square-i.caca46ac.svg";